import { createSlice } from "@reduxjs/toolkit";


export const contratStepSlice = createSlice({
    name: 'contratStep',
    initialState:{},
    reducers: { // change shopping step to manage app navigation
        nextContratStep: (currentState, action) => {
            return currentState + 1

        },
        previousContratStep: (currentState, action) => {
            return currentState - 1

        },
        
        goToContratStep: (currentState, action) => {
            return action.payload

        }
    }
});

